import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';
import { LINE_ITEM_SALES_TAX } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemSalesTaxMaybe = props => {
  const { lineItems, publicData, intl } = props;

  const salesTaxItem = lineItems.find(item => item.code === LINE_ITEM_SALES_TAX && !item.reversal);

  if (!salesTaxItem) return null;

  const formattedTax = formatMoney(intl, salesTaxItem.lineTotal);

  // Tax rate is stored as integer basis points × 100 (e.g. 775 = 7.75%)
  const rawRate = publicData?.salesTaxRate ?? publicData?.sales_tax_rate;
  const rateLabel = rawRate
    ? ` (${(rawRate / 100).toFixed(2).replace(/\.?0+$/, '')}%)`
    : '';

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>Sales tax{rateLabel}</span>
      <span className={css.itemValue}>{formattedTax}</span>
    </div>
  );
};

LineItemSalesTaxMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemSalesTaxMaybe;
